import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";
import { motion } from "framer-motion";
import { getActivePartnerships } from "../../services/partnershipsApi";
import "../Providers/PartnerCard.css";
import "./PartnerHomeBox.css";

const BYPASS_PARTNER_GATE = false;

/**
 * Box que se muestra en el Home para usuarios logueados que son proveedores.
 *   - Provider común: ve un CTA para acceder a /partners (beneficios disponibles).
 *   - Partner activo (su providerRef matchea un partnership activo): ve además
 *     un botón secundario para entrar a /partners/panel (verificación de proveedores).
 */
const PartnerHomeBox = ({ userData }) => {
    const navigate = useNavigate();
    const [isPartner, setIsPartner] = useState(false);

    useEffect(() => {
        // Detectamos si el provider logueado es partner buscando un partnership
        // activo cuyo productProviderId coincida con su providerRef.
        if (!userData?.isProvider || !userData?.providerRef) return;

        let cancelled = false;
        (async () => {
            try {
                const all = await getActivePartnerships();
                if (cancelled || !Array.isArray(all)) return;
                const match = all.some(
                    (p) => (p.productProviderId || "").toLowerCase() ===
                           (userData.providerRef || "").toLowerCase()
                );
                if (!cancelled) setIsPartner(match);
            } catch (err) {
                console.warn("[PartnerHomeBox] no se pudo verificar status de partner:", err);
            }
        })();
        return () => { cancelled = true; };
    }, [userData?.isProvider, userData?.providerRef]);

    const boxVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    };

    const handleGoToPartners = () => navigate("/partners");
    const handleGoToPanel = () => navigate("/partners/panel");

    return (
        <motion.div
            className="home-box partners-home-box"
            variants={boxVariants}
            initial="hidden"
            animate="visible"
        >
            <div
                className="partners-home-box__main"
                onClick={handleGoToPartners}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleGoToPartners(); }}
            >
                <h2 className="home-title">
                    <b>
                        <span className="partners-home-box__title-prefix">NUESTROS</span>{" "}
                        PARTNERS
                    </b>
                </h2>
                <p className="partners-home-box__subtitle">
                    <b>DESCUBRÍ LOS BENEFICIOS QUE TENÉS COMO PROFESIONAL</b>
                </p>
            </div>

            {isPartner && (
                <button
                    type="button"
                    className="partners-home-box__panel-btn"
                    onClick={(e) => { e.stopPropagation(); handleGoToPanel(); }}
                >
                    <ClipboardCheck size={16} />
                    <span>Panel Partner — verificar profesional</span>
                </button>
            )}
        </motion.div>
    );
};

export default PartnerHomeBox;
